import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GaCookieService {

 getClientId(): string | null {
    const gaCookie = this.getCookie('_ga');
    if (!gaCookie) return null;

    const parts = gaCookie.split('.');
    if (parts.length < 4) return null;

    return `${parts[2]}.${parts[3]}`;
  }

  private getCookie(name: string): string | null {
    
    const nameEQ = name + '=';
    const cookies = document.cookie.split(';');
    for (let c of cookies) {
      c = c.trim();
      if (c.startsWith(nameEQ)) {
        return c.substring(nameEQ.length);
      }
    }
    return null;
  }
}
